import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(import.meta.env.VITE_APP_MUI_XPRO_KEY ?? '')
